import { Button, Col, Modal, Row } from "react-bootstrap"
import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../../hooks/hooks";
import ErrorMessageAlert, { useAlert } from "../../common/Alert";
import TextAreaComponent from "../../common/TextAreaComponent";
import { APP_SEARCH_WARRANT } from "../../../constants/common";
import { getSearchWarrantDataForXml, updateSearchWarrantXml, useSearchWarrantReducer } from "../../../redux/slice/searchWarrantSlice";

interface EditXmlPopupProps {
  show: boolean;
  onHide: () => void;
  isCanEdit: boolean;
  formTypeName: string;
  formId: number;
}

const EditXmlPopup: React.FC<EditXmlPopupProps> = (props) => {
  const dispatch = useAppDispatch();
  const { show, onHide, formId } = props;
  const swReducer = useSearchWarrantReducer();
  const [xmlText, setXmlText] = useState("");
  const errorMessageAlert = useAlert();

  useEffect(() => {
    if (!show || !formId) return;
    setXmlText("");
    errorMessageAlert.clearError();
    dispatch(getSearchWarrantDataForXml({
      searchWarrantId:
        props.formId,
      formName: APP_SEARCH_WARRANT
    }));
  }, [show, formId, dispatch]);

  useEffect(() => {
    if (!show) return;
    setXmlText(typeof swReducer.xmlFormData === "string" ? swReducer.xmlFormData : "");
  }, [swReducer.xmlFormData, show]);

  const handleInputChange = (event: any) => {
    setXmlText(event.target.value);
  };

  const hidePopup = () => {
    onHide();
  };

  const saveXml = async () => {
    if (!formId || !xmlText?.trim()) return;
    try {
      await dispatch(
        updateSearchWarrantXml({
          searchWarrantId: formId,
          xmlData: xmlText,
        })
      ).unwrap();

      hidePopup();
    } catch (err) {
      errorMessageAlert.handleError([
        typeof err === "string" ? err : "Error while saving XML.",
      ]);
    }
  };


  return (
    <Modal
      show={show}
      onHide={hidePopup}
      centered
      backdrop="static"
      scrollable
      dialogClassName="modal-85w"
    >

      <Modal.Header closeButton>
        <b>{props.formTypeName}</b>
      </Modal.Header>
      <Modal.Body className="edit-xml-modal-body">
        <ErrorMessageAlert
          messages={errorMessageAlert.messages}
          clearError={errorMessageAlert.clearError}
        />
        <Row>
          <Col className="mt-2">
            <TextAreaComponent
              labelName="Form Data"
              name="formData"
              value={xmlText}
              onChange={handleInputChange}
              rows={25}
              className="edit-xml-textarea"
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={saveXml}>Save</Button>
        <Button variant="danger" onClick={hidePopup}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EditXmlPopup;